import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useIsRedesignEnabled } from "@src/appV2/redesign/hooks/useIsRedesignEnabled";
import { Platform } from "@src/mobile/utils/platform";

export function useIsWorkplaceUsersRedesignEnabled(): boolean {
  const isWorkplaceUsersRedesignEnabled = useCbhFlag(
    CbhFeatureFlag.WORKPLACE_USERS_REDESIGN_ENABLED,
    {
      defaultValue: false,
    }
  );
  const isRedesignEnabled = useIsRedesignEnabled();

  return isRedesignEnabled && (Platform.isMobile || isWorkplaceUsersRedesignEnabled);
}
